export default __webpack_public_path__ + "static/clean-water-5ea83ae035cedf7cecb24065f9cd98c6.png";